export default __webpack_public_path__ + "static/media/mp3.4b55b30a.svg";